export const cardSx = {
  boxShadow: '0px 0px 25px rgba(0,0,0,.25)',
  display: 'flex',
  backgroundColor: '#fff',
  pb: 2.5,
  flexDirection: 'column',
  width: {
    xs: '100%',
    md: '80%'
  },
  mx: 'auto',
  borderRadius: '5px',
  position: 'relative'
};

export const headerSx = {
  display: 'flex',
  width: '100%',
  background: 'linear-gradient(90deg,#60CE8C 17.24%,#48BDAF 100%)',
  borderRadius: '5px 5px 0 0',
  p: 3.75,
  pt: 5,
  minHeight: 160,
  color: '#fff',
  flexDirection: 'column',
  alignItems: 'center',
  '& h1': {
    color: '#fff',
    fontWeight: 300
  },
  '& svg': {
    transform: 'scale(2)',
    mb: 2.5
  }
};

export const contentSx = {
  p: 5,
  textAlign: 'center'
};

export const fieldSx = {
  maxWidth: 400,
  width: '100%',
  mb: 2
};

export const roundButtonSx = {
  mt: 2.5,
  px: '30px',
  py: '10px'
};